import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots } from "vue"

const _hoisted_1 = { key: 0 }

import { computed } from 'vue';
import { usePhieuXuatKhoTableCellApi } from './composables/usePhieuXuatKhoTableCellApi';
import {
  resolveColumnBindings,
  type PhieuXuatKhoTableColumnId,
} from './composables/usePhieuXuatKhoTableColumns';
import PhieuXuatKhoVatTuCell from './PhieuXuatKhoVatTuCell.vue';
import PhieuXuatKhoVatTuThuHoiColumns from './PhieuXuatKhoVatTuThuHoiColumns.vue';
import PhieuXuatKhoVatTuXuatKhoColumns from './PhieuXuatKhoVatTuXuatKhoColumns.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PhieuXuatKhoVatTuTableColumns',
  props: {
    visibleColumns: {}
  },
  setup(__props: any) {



const api = usePhieuXuatKhoTableCellApi();
const isSummaryMode = api.isSummaryMode;
const columnContext = computed(() => api.columnContext);

const getColumnBindings = (columnId: PhieuXuatKhoTableColumnId) =>
  resolveColumnBindings(columnId, columnContext.value, isSummaryMode);

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleColumns, (columnId) => {
    return (_openBlock(), _createElementBlock(_Fragment, { key: columnId }, [
      (columnId === 'thu_hoi')
        ? (_openBlock(), _createBlock(PhieuXuatKhoVatTuThuHoiColumns, { key: 0 }))
        : (columnId === 'vat_tu_xuat_kho')
          ? (_openBlock(), _createBlock(PhieuXuatKhoVatTuXuatKhoColumns, { key: 1 }))
          : (_openBlock(), _createBlock(_component_el_table_column, {
              key: 2,
              align: getColumnBindings(columnId).align,
              fixed: getColumnBindings(columnId).fixed,
              "header-align": "center",
              label: _unref(isSummaryMode) ? getColumnBindings(columnId).label : undefined,
              "min-width": getColumnBindings(columnId).minWidth,
              prop: columnId,
              "show-overflow-tooltip": getColumnBindings(columnId).showOverflowTooltip,
              width: getColumnBindings(columnId).width
            }, _createSlots({
              default: _withCtx((scope) => [
                _createVNode(PhieuXuatKhoVatTuCell, {
                  "column-id": columnId,
                  row: scope.row,
                  "row-index": scope.$index
                }, null, 8, ["column-id", "row", "row-index"])
              ]),
              _: 2
            }, [
              (!_unref(isSummaryMode))
                ? {
                    name: "header",
                    fn: _withCtx(() => [
                      _createElementVNode("p", {
                        class: _normalizeClass(["mb-0 w-100 text-center d-flex align-items-center justify-content-center", {
            'break-word': columnId === 'ten_vat_tu' || columnId === 'sl_dinh_muc',
          }])
                      }, [
                        (getColumnBindings(columnId).pickHeaderBold)
                          ? (_openBlock(), _createElementBlock("strong", _hoisted_1, _toDisplayString(getColumnBindings(columnId).label), 1))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode(_toDisplayString(getColumnBindings(columnId).label), 1)
                            ], 64))
                      ], 2)
                    ]),
                    key: "0"
                  }
                : undefined
            ]), 1032, ["align", "fixed", "label", "min-width", "prop", "show-overflow-tooltip", "width"]))
    ], 64))
  }), 128))
}
}

})